<template>
  <div>
    <div>
      <div>
        <el-form :inline="true"
                 :model="dataForm"
                 @keyup.enter.native="getDataList(1)"
                 @submit.native.prevent
                 label-width="100px">
          <div class="search-row">
            <div class="search-conent">
              <el-form-item label="项目名称："
                            prop="projectName">
                <el-input v-model="dataForm.projectName"
                          placeholder="请输入项目名称"
                          clearable
                          style="width:240px;"></el-input>
              </el-form-item>
            </div>
            <div class="search-conent">
              <el-form-item label="创建时间"
                            prop="demandDate">
                <el-date-picker v-model="dataForm.demandDate"
                                type="daterange"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期"
                                format="yyyy-MM-dd"
                                value-format="yyyy-MM-dd"
                                style="width:240px;">
                </el-date-picker>
              </el-form-item>
            </div>
            <div class="search-but">
              <button class="info-but"
                      @click="getCompanyCode(1)">查询</button>
            </div>
          </div>
          <div class="search-row">
            <div class="search-conent">
            </div>
            <div class="search-conent">
            </div>
            <div class="search-but">
              <button class="info-but"
                      @click="reset()">重置</button>
            </div>
          </div>
        </el-form>
      </div>
      <div>
        <div>
          <el-table :data="demandData"
                    border
                    style="width: 100%">
            <el-table-column type="index"
                             header-align="center"
                             align="center"
                             label="序号"
                             width="50"></el-table-column>
            <el-table-column prop="projectName"
                             label="项目名称"
                             align="left"
                             width="220"></el-table-column>
            <el-table-column prop="staffName"
                             label="项目负责人姓名"
                             align="center"
                             width="120"></el-table-column>
            <el-table-column prop="mobile"
                             label="项目负责人电话"
                             align="center"
                             width="120"></el-table-column>
            <el-table-column prop="demandStatus"
                             label="状态"
                             align="center"
                             width="80">
              <template slot-scope="scope">
                <span v-if="scope.row.demandStatus===1">待处理</span>
                <span v-else-if="scope.row.demandStatus===2">已受理</span>
                <span v-else-if="scope.row.demandStatus===3">已拒绝</span>
              </template>
            </el-table-column>
            <el-table-column prop="demandDate"
                             label="需求时间"
                             align="center"></el-table-column>
            <el-table-column fixed="right"
                             label="操作"
                             align="center">
              <template slot-scope="scope">
                <el-button type="text"
                           fixed
                           size="small"
                           @click="updateHandle(scope.row)">修改</el-button>
                <el-button type="text"
                           fixed
                           size="small"
                           @click="goDetail(scope.$index, scope.row)">详情</el-button>
                <el-button type="text"
                           fixed
                           size="small"
                           @click="deleteHandle(scope.row)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div class="doclist-pagination"
           v-if="demandData.length">
        <div class="doclist-lastpage"
             @click="jumpLastPage">上一页</div>
        <div class="doclist-omit">{{lastOmit}}</div>
        <ul>
          <li :class="item === currentPage?'pageactive':''"
              v-for="item in pageList"
              :key="item"
              @click="changePageTo(item)">{{item}}</li>
        </ul>
        <div class="doclist-omit">{{nextOmit}}</div>
        <div class="doclist-nextpage"
             @click="jumpNextPage">下一页</div>
        <div class="doclist-pagejump">共{{totalPage}}页，到第<input type="text"
                 v-model.number="jumpTargetPage">页</div>
        <div class="doclist-jump"
             @click="jumpFarPage">确定</div>
      </div>
    </div>
  </div>
</template>

<script>

import Cookies from 'js-cookie'
export default {
  props: {
    nedshow: {
      type: Boolean
    }
  },
  data () {
    return {
      djbh: '',
      value: '',
      djztOptions: [],
      djzt: '',
      activeName: 'first',
      tableData: [],
      demandData: [],
      dialogVisible: false,
      customerCode: '',
      ruleForm: {
        djbh: '',
        kh: '',
        xqms: '',
        cjsj: '',
        djzt: ''
      },
      rules: {
        djbh: [
          { required: true, message: '请输入项目编号', trigger: 'blur' }
        ],
        kh: [
          { required: true, message: '请输入客户', trigger: 'blur' }
        ],
        djzt: [
          { required: true, message: '请选择单据状态', trigger: 'change' }
        ],
        cjsj: [
          { type: 'date', required: true, message: '请选择日期', trigger: 'change' }
        ],
        xqms: [
          { required: true, message: '请填写客户描述', trigger: 'blur' }
        ]
      },
      row: null,
      dataForm: {
        projectName: '',
        demandDate: '',
        status: null
      },
      // 分页
      currentPage: 1, // 当前页
      totalPage: 4, // 总页数
      lastOmit: '',
      nextOmit: '...',
      pageList: [1, 2, 3, 4, 5],
      jumpTargetPage: 1 // 跳转页
    }
  },
  methods: {
    formatData () {
      this.currentPage = 1
      this.totalPage = 1
      this.lastOmit = ''
      this.nextOmit = '...'
      this.pageList = [1, 2, 3, 4, 5]
    },
    routerHandle (routerName) {
      this.$router.push(routerName)
    },
    add () {
      this.$router.push({ name: 'projectDemandNew' })
    },
    updateHandle (row) {
      if (row.demandStatus === 1) {
        this.$router.push({ name: 'projectDemandNew', query: { id: row.billId } })
      } else if (row.demandStatus === 2) {
        this.$message.error('已受理不可编辑')
      } else if (row.demandStatus === 3) {
        this.$message.error('已拒绝不可编辑')
      }
    },
    deleteHandle (row) {
      if (row.demandStatus === 1) {
        this.deleteData(row.billId)
      } else if (row.demandStatus === 2) {
        this.$message.error('已受理不可删除')
      } else if (row.demandStatus === 3) {
        this.$message.error('已拒绝不可删除')
      }
    },
    deleteData (id) {
      this.$confirm(`确定删除该项目实施需求单?`,
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }
      ).then(() => {
        this.$http.post(`${window.SITE_CONFIG['baseURL']}/insale/projectdemand/delete`, {
          billId: id
        }).then((data) => {
          if (data.result.code === 0) {
            this.$message({
              message: '删除成功',
              type: 'success',
              duration: 1500,
              onClose: () => {
                this.getDemandData()
              }
            })
          }
        }).catch(() => { })
      })
    },
    goDetail (index, row) {
      this.$router.push({
        name: 'projectDemandDetail',
        query: { id: row.billId }
      })
    },
    // 需求单详细
    fetchData (currentPage = this.currentPage) {
      this.$http.post(`${window.SITE_CONFIG['baseURL']}/insale/insalelist/viewList`, {
        'page': currentPage,
        'limit': 10,
        'projectName': this.dataForm.projectName,
        'startDate': this.dataForm.demandDate && this.dataForm.demandDate.length >= 1 ? this.dataForm.demandDate[0] : '',
        'endDate': this.dataForm.demandDate && this.dataForm.demandDate.length === 2 ? this.dataForm.demandDate[1] : '',
        'customerno': this.customerCode,
        'userteleno': this.$store.getters.userInfo.mobile,
        'projid': '',
        'state': '',
        'createdate': ''
      }).then(data => {
        this.totalPage = Math.ceil(data.total / 10)
        this.tableData = data.result
        this.setPageTo(currentPage)
      }).catch(() => {
        this.tableData = []
      })
    },
    getCompanyCode (page) {
      this.$http.get(`${window.SITE_CONFIG['baseURL']}/businessOffice/businesscorporateclients/clientUserInfo/` + Cookies.get('userId')).then(data => {
        this.customerCode = data.result.data.customerCode
        this.fetchData(page)
      }).catch(() => { })
    },
    // 上一页
    jumpLastPage () {
      if (this.currentPage > 1) {
        var newCurrent = this.currentPage - 1
        this.changePageTo(newCurrent)
      } else {
        this.$message.info('这已经是第一页啦')
      }
    },
    //  下一页
    jumpNextPage () {
      if (this.currentPage < this.totalPage) {
        var newCurrent = this.currentPage + 1
        this.changePageTo(newCurrent)
      } else {
        this.$message.info('这已经是最后一页啦')
      }
    },
    //   第几页
    changePageTo (page) {
      this.getCompanyCode(page)
    },
    //   确定跳转到哪页
    jumpFarPage () {
      if (this.jumpTargetPage >= 1 && this.jumpTargetPage <= this.totalPage) {
        this.changePageTo(this.jumpTargetPage)
      } else {
        this.$message.error('请输入正确的页码')
      }
    },
    setPageTo (page) {
      if (this.totalPage > 5) {
        if (page > 2 && page < this.totalPage - 1) {
          var newPageList = []
          for (let index = page - 2; index < page + 3; index++) {
            newPageList.push(index)
          }
          this.pageList = newPageList
          this.currentPage = page
          this.lastOmit = '...'
          this.nextOmit = '...'
        } else if (page <= 2) {
          this.pageList = [1, 2, 3, 4, 5]
          this.currentPage = page
          this.lastOmit = ''
          if (page >= this.totalPage - 2) {
            this.nextOmit = ''
          } else {
            this.nextOmit = '...'
          }
        } else {
          var newPageList2 = [this.totalPage - 4, this.totalPage - 3, this.totalPage - 2, this.totalPage - 1, this.totalPage]
          this.pageList = newPageList2
          this.currentPage = page
          this.lastOmit = '...'
          this.nextOmit = ''
        }
      } else {
        var newPageList5 = []
        for (let index = 1; index <= this.totalPage; index++) {
          newPageList5.push(index)
        }
        this.pageList = newPageList5
        this.lastOmit = ''
        this.nextOmit = ''
        this.currentPage = page
      }
    },
    // 清空form
    reset () {
      this.dataForm = {
        projectName: '',
        demandDate: '',
        status: null
      }
      this.getCompanyCode(1)
    }
  },
  mounted () {
    this.getCompanyCode()
  }
}
</script>

<style scoped>
.new {
  padding: 10px 0px;
}
.deatal-info-but {
  background: #ffffff;
  width: 96px;
  height: 40px;
  text-align: center;
  line-height: 38px;
  font-size: 14px;
  color: #1d65a8;
  letter-spacing: 0;
  border: none;
  cursor: pointer;
  user-select: none;
  border: none;
  margin-right: 10px;
}
.deatal-info-but:hover {
  background: #e8f7f6;
}
.search-row {
  display: flex;
}
.search-conent {
  min-width: 350px;
  margin-right: 20px;
}
.search-but {
  width: 100%;
  min-width: 200px;
  text-align: right;
}
.opt-row {
  width: 100%;
  display: flex;
  text-align: right;
  margin-bottom: 20px;
}
.opt-right {
  width: 300px;
}
.opt-left {
  width: 100%;
  text-align: left;
}
.info-but {
  background: #ffffff;
  width: 96px;
  height: 40px;
  text-align: center;
  line-height: 38px;
  font-size: 14px;
  color: #1d65a8;
  letter-spacing: 0;
  border: none;
  cursor: pointer;
  user-select: none;
  border: 1px solid #1d65a8;
  margin-right: 10px;
}
.info-but:hover {
  background: #1d65a8;
  color: #ffffff;
}
.info-but-new {
  background: #1d65a8;
  color: #ffffff;
}
.tabs {
  margin: 0 18px 10px 18px;
}
</style>
